import React from 'react';
import http from '@/services/http';
import { ASSIGNMENT_DECISIONS_URL, ORDER_EVENTS_URL } from './urls';

// The activity feed's backfill. The socket carries every event from the moment
// the live page connects; this fills in what happened before that, so a reload
// does not start the timeline from nothing.
//
// Extends React.Component like every other controller here — historical
// copy-paste, they are plain service objects. Never throws: returns
// { error: true } and lets the caller decide.
class OrderEventController extends React.Component {
	// `since` is the newest row already held, as an ISO string. Passing it turns a
	// reconnect into a small query instead of the whole window.
	//
	// `until` closes the window at the top, which only the board's date filter
	// needs: without it, asking for one past day returns that day and everything
	// after it, and the server's 400-row cap then hands back today instead.
	get = async ({ cityId, since, until } = {}) => {
		let data;

		try {
			// http.get's second argument IS the query object — it wraps it in
			// `{ params }` itself (services/http.js). Passing an axios config here
			// instead nested it one level deep, so the server saw `params[cityId]`
			// and no cityId at all: a master got "city not found" on every reload
			// and the feed showed its error state until the first live event.
			const res = await http.get(ORDER_EVENTS_URL, {
				...(cityId ? { cityId } : {}),
				...(since ? { since } : {}),
				...(until ? { until } : {}),
			});
			data = res?.data;
		} catch (error) {
			console.log(error);
			return { error: true };
		}

		if (!data || data.error) {
			return { error: true, code: data?.code };
		}

		return { events: Array.isArray(data.events) ? data.events : [] };
	};

	// Why the automatic check picked that rider, for one order. Keyed on the live
	// order id, so it only answers for orders still on the board — which is when
	// the question gets asked.
	getDecisions = async orderId => {
		let data;

		try {
			const res = await http.get(`${ASSIGNMENT_DECISIONS_URL}${orderId}`);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return { error: true };
		}

		if (!data || data.error) {
			return { error: true, code: data?.code };
		}

		return { decisions: Array.isArray(data.decisions) ? data.decisions : [] };
	};
}

export default new OrderEventController();
